import type { SemanticModel } from '@aibi/contracts';
import { stableHash } from '@aibi/shared';

/** JSON con claves ordenadas: dos documentos equivalentes producen el mismo texto. */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(value, (_key, current: unknown) => {
    if (current === null || typeof current !== 'object' || Array.isArray(current)) return current;
    const entries = Object.entries(current as Record<string, unknown>).sort(([a], [b]) =>
      a < b ? -1 : a > b ? 1 : 0,
    );
    return Object.fromEntries(entries);
  });
}

/**
 * Huella del contenido del modelo, estable entre ejecuciones. Excluye `revision` y
 * `updatedAt` para que solo cambie cuando cambia el contenido. Combina dos hashes
 * FNV-1a de 32 bits para reducir colisiones.
 *
 * @example
 * modelFingerprint(before) === modelFingerprint(after) // sin cambios reales
 */
export function modelFingerprint(model: SemanticModel): string {
  const { metadata, ...content } = model;
  const stableMetadata =
    metadata === undefined
      ? undefined
      : Object.fromEntries(
          Object.entries(metadata).filter(([key]) => key !== 'revision' && key !== 'updatedAt'),
        );
  const text = canonicalJson({ ...content, metadata: stableMetadata });
  return `${stableHash(text, 7)}${stableHash(`#${text}`, 7)}`;
}
